import { connectedStore } from '../../store';
import pasteElementAction from '../actions/paste-element';
import { USED_ACTION_CREATOR } from '../constants/symbols';

const pasteElement = (refElementId, position, options) => {
  const store = connectedStore.get();
  store.dispatch(pasteElementAction(refElementId, position, options));
};

pasteElement[USED_ACTION_CREATOR] = pasteElementAction;

export default pasteElement;
